import React, { useState } from 'react'
const Search = ({ config, doSearch }) => {
    return (
        <input type="text" className="form-input search" placeholder={config.placeholder} onChange={(e) => doSearch( e.target.value )}/>
    )
}
export default Search